<template>
  <div class="d-flex w-100 h-max-content" :key="$store.state.auth.token" :class="containerClass">
    <section class="flex-fill overflow-auto_ left-section d-flex flex-column" :class="{ 'tour-active': !!activeTour }">
      <top-bar :showUsers="false" :style="[isIntegrationBannerVisible ? { 'margin-bottom': '0 !important' } : {}]" />
      <div
        v-if="isIntegrationBannerVisible"
        class="banner w-100 bg-primary d-flex align-items-center justify-content-center py-3"
      >
        <b class="font-weight-bold text-white" style="font-size: 1.5rem; letter-spacing: -0.3px"
          >Autofill your referrals with our integration</b
        >
        <calendly><a href="javascript:void(0)" class="btn btn-lg px-5 btn-info ml-3">Upgrade</a></calendly>
      </div>
      <main class="flex-grow-1 d-flex mt-md-3">
        <div class="container-fluid d-flex p-0 px-md-5" v-if="isLoggedIn">
          <slot />
        </div>
      </main>
    </section>
    <LoggedInCommon v-if="isLoggedIn && $route.name !== '404'" />
  </div>
</template>

<script>
import TopBar from './TopBar'
import RegisterModal from '@/components/_layout/RegisterModal'
import Calendly from '@/components/shared/Calendly'
import LoggedInCommon from '@/components/_layout/LoggedInCommon'
import { mapState, mapGetters } from 'vuex'
import 'hooper/dist/hooper.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import '@voerro/vue-tagsinput/dist/style.css'
export default {
  components: {
    TopBar,
    LoggedInCommon,
    Sms: () => import('@/components/_layout/Sms'),
    Calendly,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('settings', ['isPaymentModalVisible', 'isBannerVisible']),
    ...mapState('tour', ['activeTour']),
    isIntegrationBannerVisible() {
      const practice = this.user?.practice
      return (
        // practice?.specialty == 0 &&
        practice?.is_integration_active === false && this.isBannerVisible && !practice?.has_active_subscription
      )
    },
    containerClass() {
      return this.$route.meta.containerClass
    },
  },
  async created() {},
  methods: {},
  mounted() {},
}
</script>
<style scoped>
.left-section {
  height: 100vh;
}
.h-max-content {
  height: max-content;
}
.sidebar {
  max-width: 400px;
  width: 25%;
  min-height: 100vh;
}
.banner {
  background-image: url('~@/assets/svg/banner-bg.svg');
  background-position: 50% -16px;
}
</style>
